
export const FOOTER_LINKS_COOKIES_SETTINGS = "Настройки cookies"
